import classnames from 'classnames';

import type { AlertTitleProps } from './alert.types';

import './alert-title.scss';

function AlertTitle(props: AlertTitleProps): JSX.Element {
  const { children, className } = props;

  return <div className={classnames('rbui-alert-title', className)}>{children}</div>;
}

export default AlertTitle;
